import React from "react";
import axios from "axios";
import config from "./config";
import { Base64 } from 'js-base64';

//COMMON VARIABLE OF USER DERAILS
let userId, userRole, userEmail, userToken, syncToken, streamData;

class vendorApiCall extends React.Component {

    static async makeApiCall(type, info, apiPath, fileObject) {
        let apiResult = { success: false, APIResult: {}, expired: false };
       
        
        userId =config.instructorInfo.data.vendorId;
        userRole = 'vendor';
        userEmail = config.instructorInfo.data.EmailId;
        userToken = config.user_token;
        syncToken = config.sync_token;
      
        
        let formdata = new FormData();
        formdata.append(type, true);
        formdata.append('data', Base64.encode(JSON.stringify(info)));

        let parameterData = JSON.stringify({
            
            source: 'app',
            uid: userId,
            email: userEmail,
            role: userRole
        });
        
        if(fileObject) {
            formdata.append('file[]', fileObject);
        } 
     
        
        formdata.append('tokenInputParameter', Base64.encode(parameterData));

        await axios({
            method: "post",
            url: config.RootUrl + apiPath,
            data: formdata,
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
                "Authorization": "Basic " + userToken
            },
        }).then((response) => {
            
            let jsonResponse = response.data;
            if (jsonResponse.errorCode == "401") {
                this.generateTokenAPICall();
                apiResult.expired = true;
            }
            else if (jsonResponse.success == 'true') {
                apiResult.success = true;
                apiResult.APIResult = jsonResponse;
            }

        }).catch(err => console.log("Student Details API call error", err))

        return apiResult;
    }

    static generateTokenAPICall = (type, info) => {
        let formdata = new FormData();
        formdata.append('GenerateAccessToken', true);

        let parameterData = JSON.stringify({
            source: 'app',
            uid: userId,
            email: userEmail,
            role: userRole
        });

        formdata.append('data', Base64.encode(parameterData));

        axios({
            method: "post",
            url: config.RootUrl + "/login/api/tokenManagement.php",
            data: formdata,
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data"
            },
        }).then((response) => {
            let jsonResponse = response.data;
            if (jsonResponse.status == 'success') {
                function setCookie(name,value) {
                    document.cookie = name + "=" + (value || "") + "; path=/";
                }

                config.user_token = jsonResponse.data.user_token;
                config.sync_token = jsonResponse.data.sync_token;

                setCookie('user_token_wc', jsonResponse.data.user_token);
                setCookie('sync_token_wc', jsonResponse.data.sync_token);
            }

        }).catch(err => console.log("Generate token api error", err))
    }
}

export default vendorApiCall;